import React, { useState } from "react";
import Loader from "shared/Loader";
import classNames from "classnames";
import styles from "./index.module.css";

/**
 * Form component for embedding form controls.
 * - Handles and displays validation errors.
 * - Takes an `async` onSubmit function and displays a loader
 * while that Promise is pending.
 */
export function Form({ children, onSubmit, className, ...props }) {
  const [submitting, setSubmitting] = useState(false);

  return (
    <form
      {...props}
      className={classNames(styles.container, className)}
      onSubmit={(e) => {
        e.preventDefault();

        if (onSubmit) {
          const value = onSubmit(e);

          if (value instanceof Promise) {
            setSubmitting(true);

            onSubmit(e).finally(() => {
              setSubmitting(false);
            });
          }
        }
      }}
    >
      <div
        className={classNames(styles.main, {
          [styles.locked]: submitting,
        })}
      >
        {children}
      </div>

      {submitting && (
        <div className={styles.loader}>
          <Loader />
        </div>
      )}
    </form>
  );
}
